<template>
  <div>
    <!--<ui-icon :to="to" v-bind:style="{fontSize:'1.5em'}"  class="icon" backgroundColor="#DDDDDD" color="#999999" icon="arrow-left"></ui-icon>-->
  <ui-icon @click.native="back" v-bind:style="{fontSize:'1.5em'}"  class="icon" backgroundColor="#DDDDDD" color="#666666" icon="arrow-left"></ui-icon>

  </div>
</template>

<script>

import UiIcon from '../UiIcon.vue';
import { mapState } from 'vuex';
import { history } from "../../services/History.js";

export default {
  name: 'icon-button-back',
  props:{
    to:{default:""}
  },
  computed:{
    ...mapState(['user_schools'])
  },
  data:function(){
    return {
      prevRoute:null
    }
  },
  methods:{
    back(){
      if(this.to==""){
        this.$router.push(history.get());
      }else{
        this.$router.push(this.to);
      }
      
    }
  },
  components:{
    UiIcon
  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.icon{
  cursor:pointer
}
</style>
